/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.6.3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { UserFromJSON, UserToJSON, } from './';
export function WorkorderAssetCreateCommandFromJSON(json) {
    return WorkorderAssetCreateCommandFromJSONTyped(json, false);
}
export function WorkorderAssetCreateCommandFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'workorderAssetId': !exists(json, 'workorderAssetId') ? undefined : json['workorderAssetId'],
        'workorderId': !exists(json, 'workorderId') ? undefined : json['workorderId'],
        'assetId': !exists(json, 'assetId') ? undefined : json['assetId'],
        'user': !exists(json, 'user') ? undefined : UserFromJSON(json['user']),
        'pmScheduleID': !exists(json, 'pmScheduleID') ? undefined : json['pmScheduleID'],
        'problem': !exists(json, 'problem') ? undefined : json['problem'],
        'remedy': !exists(json, 'remedy') ? undefined : json['remedy'],
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
        'doneFlag': !exists(json, 'doneFlag') ? undefined : json['doneFlag'],
        'downtime': !exists(json, 'downtime') ? undefined : json['downtime'],
        'meterReading': !exists(json, 'meterReading') ? undefined : json['meterReading'],
    };
}
export function WorkorderAssetCreateCommandToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'workorderAssetId': value.workorderAssetId,
        'workorderId': value.workorderId,
        'assetId': value.assetId,
        'user': UserToJSON(value.user),
        'pmScheduleID': value.pmScheduleID,
        'problem': value.problem,
        'remedy': value.remedy,
        'notes': value.notes,
        'doneFlag': value.doneFlag,
        'downtime': value.downtime,
        'meterReading': value.meterReading,
    };
}
